import bg_top from './img/bg-top.png'
import bg_br from './img/br.png'
import bg_bl from './img/bl.png'
import bg_tl from './img/tl.png'
import bg_tr from './img/tr.png'
import top from './img/top.png'
import bg_top_m from './img/bg-top-m.png'
import bg_top_m2 from './img/bg-top-m2.png'
import image from './img/image.png'
import thumb from './img/thumb.png'
import bg from './img/promo4/bg_top.png'
import d1 from './img/promo4/t.png'
import txs from './img/promo4/t-xs.png'
import lt from './img/promo4/lt.png'
import lb from './img/promo4/lb.png'
import bg_prize from './img/promo4/bg_prize.png'
import ll from './img/promo4/ll.png'
import lr from './img/promo4/lr.png'
import logo from './img/promo4/logo.svg'

export const img = {
  bg_top,
  top,
  bg_top_m,
  bg_top_m2,
  bg_br,
  bg_bl,
  bg_tl,
  bg_tr,
  image,
  thumb,
  bg,
  d1,
  lt,
  lb,
  ll,
  lr,
  logo,
  bg_prize,
  txs
}

type AllImagesObject = { [key: string]: string }
const getAllImagesObject = (r: __WebpackModuleApi.RequireContext) => {
  const images: AllImagesObject = {}
  r.keys().map((item: string) => {
    const imgItem = r(item)
    images[item.replace('./', '')] = imgItem.default
    return item
  })
  return images
}

export const ruleIcons = getAllImagesObject(require.context('./img/promo4', false, /.png/))
export const questIcons = getAllImagesObject(require.context('./img/quest', false, /.png/))

export const prizeIcons = getAllImagesObject(require.context('./img/promo4', false, /.png/))
